import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import type { IConnection, IUser } from '../models/Unified';
import { get, setApiToken } from '../services/api';

export type UserData = {
    user?: IUser;
    // workspace?: IWorkspace;
    token?: string;
    imageUrl?: string;
};

export const useUserSession = defineStore('userSession', () => {
    // token will be synced with local storage
    // @see https://vueuse.org/core/usestorage/

    let connections: IConnection[] = [];

    // load saved user data
    const user = useStorage('user', ''); // ref<Partial<UserData>>();
    console.log('user-session', user);
    let userObj: UserData = {};
    try {
        if (user.value) {
            userObj = JSON.parse(user.value);
        }

        // console.log('userSession', userObj);
        if (userObj?.token) {
            setApiToken(userObj.token);
            fetchUser();
        } else if (window) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const token = urlParams.get('token');
            console.log('token', queryString, urlParams, token);
            if (token) {
                setToken(token);
                setApiToken(token);
            }
        }
    } catch (err) {
        // console.error('user-session-error', err);
    }

    function setUserImage(url: string) {
        if (!userObj) {
            userObj = {
                imageUrl: url,
            };
        } else {
            userObj.imageUrl = url;
        }
        setUser();
    }

    // function setWorkspace(w: IWorkspace) {
    //     if (userObj) {
    //         userObj.workspace = w;
    //     } else {
    //         userObj = {
    //             workspace: w,
    //         };
    //     }
    //     setUser();
    // }

    function setUser(newUser?: IUser) {
        // console.log('save user');
        if (newUser) {
            if (!userObj) {
                userObj = {
                    user: newUser,
                };
            } else {
                userObj.user = newUser;
            }
        }
        user.value = JSON.stringify(userObj);
    }

    async function setToken(newToken: string) {
        // console.log('setToken');

        userObj = {
            token: newToken,
        };

        setApiToken(newToken);

        await fetchUser();

        setUser();
    }

    // function setLoading(newLoading: boolean) {
    //     console.log('setLoading', newLoading);
    //     loading.value = newLoading;
    // }
    async function logout() {
        if (userObj) {
            userObj.token = '';
        }
        user.value = undefined;
    }

    async function fetchUser() {
        const user = await get<IUser>('unified/user');
        // console.log('fetchUser', user);
        if (user) {
            setUser(user);
            // await fetchWorkspace();
        }

        await fetchConnections();
        return user;
    }

    async function fetchConnections() {
        if (!connections?.length) {
            console.log('fetchConnections');
            connections = (await await get<IConnection[]>(`unified/connection?sort=name`)) || [];
        }
        return connections;
    }

    // async function fetchWorkspace() {
    //     const workspace = await get<IWorkspace>('unified/workspace');
    //     console.log('fetchWorkspace', workspace);
    //     if (workspace) {
    //         setWorkspace(workspace);
    //     }
    // }

    function getToken() {
        return userObj?.token;
    }

    async function getUser() {
        if (userObj.token && !userObj.user) {
            await fetchUser();
        }
        return userObj?.user;
    }

    // function getWorkspace() {
    // return userObj?.workspace;
    // }

    function getUserImage() {
        return userObj?.imageUrl;
    }

    function initialized() {
        return userObj?.token !== undefined && userObj?.token !== '';
    }

    function isLoggedIn() {
        return userObj?.token !== undefined && userObj?.token !== '';
    }

    return {
        getUser,
        // getWorkspace,
        getToken,
        getUserImage,
        initialized,
        isLoggedIn,
        logout,
        setUser,
        setToken,
        // setWorkspace,
        setUserImage,
        fetchUser,
        fetchConnections,
    } as const;
});

/**
 * Pinia supports Hot Module replacement so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
// if (import.meta.hot) {
//     import.meta.hot.accept(acceptHMRUpdate(useUserSession, import.meta.hot));
// }
